/**
 * Register the offline shell.
 *
 * Only in a production build: a service worker in front of the Vite dev server
 * serves stale modules and turns "my change did not appear" into a half-hour of
 * confusion.
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return
  if (!('serviceWorker' in navigator)) return

  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // A browser that refuses the worker still gets a working application;
      // there is nothing useful to tell the person about it.
    })
  })
}
